import { render } from "./InspectionTypeCreateForm.vue?vue&type=template&id=d12bef36"
import script from "./InspectionTypeCreateForm.vue?vue&type=script&lang=js"
export * from "./InspectionTypeCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__